export default "__VITE_ASSET__4QYkbfCK__"